import { render, staticRenderFns } from "./Historical.vue?vue&type=template&id=ba04f870&scoped=true"
import script from "./Historical.vue?vue&type=script&lang=js"
export * from "./Historical.vue?vue&type=script&lang=js"
import style0 from "./Historical.vue?vue&type=style&index=0&id=ba04f870&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba04f870",
  null
  
)

export default component.exports